import React, { useState } from 'react';
import { Modal, Input, Row, Form } from 'antd';
import { renameModel } from '../../../lib/api/algorithm-api';
import { Model } from '../../../types';
import { ModalTitle } from '../../../components/text/Titles';

type Props = { visible: boolean; onClose: () => any; onCancel: () => any; model: Model };

export const RenameModel = (props: Props) => {
  const { visible, onClose, onCancel, model } = props;

  const [name, setName] = useState<null | string>(model.name);

  const onRename = async () => {
    if (!name) return;

    const request = await renameModel(name, model.id);
    console.log(request);
    onClose();
  };

  return (
    <Modal
      maskClosable={false}
      width={768}
      visible={visible}
      title={<ModalTitle>Rename model: {model.name}</ModalTitle>}
      onOk={onRename}
      onCancel={onCancel}>
      <>
        <Row style={{ marginTop: '16px' }}>
          <Form layout={'vertical'}>
            <Form.Item label="Name">
              <Input value={name || undefined} onChange={event => setName(event.target.value)} />
            </Form.Item>
          </Form>
        </Row>
      </>
    </Modal>
  );
};
